import { EditorView } from '@codemirror/view';

export const baseEditorTheme = EditorView.theme({
    "&": {
        fontSize: "16px",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        height: "100%",
        caretColor: "var(--color-text-primary)",
    },
    ".cm-content": {
        fontFamily: "inherit",
        padding: "1rem",
        color: "var(--color-text-primary)",
        caretColor: "var(--color-text-primary)",
    },
    ".cm-line": {
        padding: "0.2rem 0.5rem",
        lineHeight: "1.6",
    },
    ".cm-gutters": {
        minWidth: "20px",
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
        paddingLeft: "22px",
    },
    ".cm-gutter": {
        minWidth: "20px",
        backgroundColor: "transparent",
    },
    ".cm-gutter-lint": {
        width: 0,
        display: "none",
    },
    ".cm-lineNumbers": {
        width: "32px",
    },
    ".cm-lineNumbers .cm-gutterElement": {
        padding: "0 4px",
        minWidth: "28px",
        color: "var(--color-text-tertiary)",
    },
    ".cm-scroller": {
        overflow: "auto",
        lineHeight: "1.6",
    },
    ".cm-activeLine": {
        backgroundColor: "var(--color-cm-active-line)",
    },
    ".cm-activeLineGutter": {
        backgroundColor: "var(--color-cm-active-line-gutter)",
        color: "var(--color-text-secondary)",
    },
    ".cm-cursor, .cm-dropCursor": {
        borderLeftColor: "var(--color-text-primary) !important",
        borderLeftWidth: "2px",
    },
    "&.cm-focused .cm-cursor": {
        borderLeftColor: "var(--color-text-primary) !important",
    },
    ".cm-cursor-primary": {
        borderLeftColor: "var(--color-text-primary) !important",
    },
    "&.cm-editor.cm-focused .cm-cursor": {
        borderLeftColor: "var(--color-text-primary) !important",
    },
    ".cm-inline-comment": {
        color: "var(--color-text-tertiary)",
        fontStyle: "italic",
        opacity: "0.7",
    },
});

// Scrollbar styles
export const scrollbarStyles = EditorView.theme({
    ".cm-scroller": {
        "&::-webkit-scrollbar": {
            width: "6px",
            height: "6px",
        },
        "&::-webkit-scrollbar-track": {
            background: "var(--color-scrollbar-track)",
        },
        "&::-webkit-scrollbar-thumb": {
            background: "var(--color-scrollbar-claims-thumb)",
            borderRadius: "3px",
            "&:hover": {
                background: "var(--color-scrollbar-claims-thumb-hover)",
            },
        },
        "scrollbar-width": "thin",
        "scrollbar-color": "var(--color-scrollbar-claims-thumb) var(--color-scrollbar-track)",
    },
});
